export default {
  common: {
    regionZone: "Region/Gebiet",
    seller: "Vertriebsmitarbeiter",
    chillerOrPlant: "Zielsetzung",
    dateRange: "Datumsbereich",
    showNumber: "Anzahl anzeigen",
    hallOfFame: "Bestenliste",
    statisticChart: "Statistikdiagramm",
    win: "Gewinnen",
    pipeline: "Pipeline",

    chillerAndChillerPlant: "Flüssigkeitskühler und Kältezentrale",
    chiller: "Effizienz des Flüssigkeitskühlers",
    chillerPlant: "Wirkungsgrad der Kältezentrale",
    heating: "Heizungswirkungsgrad",

    ChillerRetrofit: "Modernisierung des Flüssigkeitskühlers",
    ChillerPlantRetrofit: "Modernisierung der Kältezentrale",
    HeatingElectricRetrofit: "Umrüstung von Heizkessel auf Wärmepumpe",

    regions: "Regionen",
    zones: "Gebiete",

    resetPipelineCheckMesg:
      "Das System wird die Snapshot-Daten des letzten Monats durch die aktuellen Pipeline-Daten ersetzen. Diese Operation ist irreversibel. Sind Sie sicher, dass Sie diese Operation durchführen möchten?",
    resetPipeline: "Pipeline zurücksetzen",
    resetLastMonthPipelinedata: "Zurücksetzen der Pipelinedaten des letzten Monats",

    verificationCode: "Bestätigungscode",
    enterVerificationCode: "Bitte geben Sie den Bestätigungscode ein, um den Vorgang zu bestätigen",
    verificationCodeError: "Der Bestätigungscode ist falsch",

    note: "Hinweis",
    dataBefore202601: "Die Daten für Januar 2026 und früher stammen von Version 1.0 und unterstützen derzeit keine Abfragen nach 'Projektstatus' und 'Projektzielen'.",
    iKnowThis: "Schließen",
    availableWhen202602: "Verfügbar für Datumsbereiche ab Februar 2026"
  }
}



// WEBPACK FOOTER //
// ./src/locale/dashboard/de.js